import { h } from 'preact';
// import Store from 'store/store';
import * as categories from '../categories';
import * as tealiumCategories from './categories';
import * as queue from '../queue';
import { dispatchEvent } from '../dispatchEvent';

export { default as Pixel } from '../Pixel';
export { maybeHandle } from '../maybeHandle';
export { default as connectToOneTrust } from '../oneTrust/connectToOneTrust';
export { default as createPixelComponent } from '../createPixelComponent';

export { STRICTLY_NECESSARY, FUNCTIONAL, TARGETING, ADVERTISING } from '../constants';

categories.addChangeListener((allowedCategories) => {
	dispatchEvent('categoriesUpdated', { categories: allowedCategories });
	queue.drain(allowedCategories);
});

// just rely on window.utag.gdpr.getCookieValues
// we used to filter out most of the keys here but not anymore (just the ones that are not activated, with value "0") - categories.js is the file in charge of using the values or ignoring the irrelevant ones
function getCookieCategories() {
	if (!window.utag) {
		return [];
	}
	const values = window.utag.gdpr.getCookieValues();
	return Object.keys(values).filter(key => values[key] === '1' || values[key] === 'true');
}
if (typeof window !== 'undefined') {
	const useTealium = window.__INITIAL_STATE__?.appData?.options?.enableTealiumCookieConsent;
	if (useTealium) {
		const updateCategories = () => tealiumCategories.set(getCookieCategories());

		// as before, we update the categories when receiving this event (Disney telling us the cookie settings have been saved)
		window.addEventListener('consentdecided', updateCategories);
		// and if the script utag.js has already loaded (and set window.utag), we can check the categories immediately
		if (window.utag) {
			updateCategories();
		} else {
			// but if it's not loaded yet, then every time something finishes loading on the page (image, script, etc.) we check if it's the relevant script and check the categories if that's the case
			// (once utag.js is loaded, we remove the listener as we don't need to monitor loads anymore)
			const checkLoad = e => {
				if (e.target.matches('script[src$="utag.js"]')) {
					document.removeEventListener('load', checkLoad, true);
					updateCategories();
				}
			};
			document.addEventListener('load', checkLoad, true);
		}
	}
}
